export default "__VITE_ASSET__CaJ06lYg__"